import axios from '../axios'

/* 
 * 店铺模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/shop/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/shop/delete',
        method: 'post',
        data
    })
}
// 查询
export const findPage = (data) => {
    return axios({
        url: '/shop/findPage',
        method: 'post',
        data
    })
}
export const findPageAll = (data) => {
    return axios({
        url: '/shop/findPageAll',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/shop.js